import { Updater, AsyncState, loadingAsyncState } from 'widgets-for-react'
import { PaginationState, initialPaginationState } from '../pagination/paginationState'
import { SpaarneDepartmentType } from '../../utils/spaarneIcons'
import { getSearchData } from './searchPageApi'
import { ImageBase } from '../../utils/image'

export type SearchPageState = {
  searchTerm: string
  searchResultState: AsyncState<SearchResult>
  paginationState: PaginationState
}

export type SearchResult = {
  hits: SearchHits[]
  suggestions: string[]
}

type SearchHits = {
  label:
    | 'Evenement'
    | 'Afdeling'
    | 'Locatie'
    | 'Nieuws'
    | 'Onderzoek'
    | 'Specialist'
    | 'Subafdeling'
    | 'Wachttijd'
    | 'Pagina'
    | 'Centrum'
    | 'Folder'
    | 'Folder pagina'
    | 'Dossier'
    | 'error'
  // id: number
  title: string
  description?: string
  image?: ImageBase
  url: string
  publishingDate?: Date
  eventDate?: Date
  departmentTitle?: SpaarneDepartmentType
  subDepartmentTitle?: string
}

export const initialSearchPageState = (page: number, term: string, lang: string): SearchPageState => ({
  paginationState: initialPaginationState(`/api/v1/search/count/pages?query=${term}&lang=${lang}`),
  searchTerm: term,
  searchResultState: loadingAsyncState(() => getSearchData(term, page, lang)),
})

export const SearchStateUpdaters = {
  updateSearchResultState:
    (updater: Updater<AsyncState<SearchResult>>) =>
    (currentState: SearchPageState): SearchPageState => ({
      ...currentState,
      searchResultState: updater(currentState.searchResultState),
    }),
  updatePaginationState:
    (updater: Updater<AsyncState<number>>) =>
    (currentState: SearchPageState): SearchPageState => ({
      ...currentState,
      paginationState: updater(currentState.paginationState),
    }),
}
